import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { OptionsService } from '../services/options.service'
import { IOptionsResponse } from '../../../common/common.types'
import { setConsentFormSignedOption } from '../store/options.actions'

export function* getConsentFormSignedOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getConsentFormSignedOptions])
    const { entity } = response
    yield put(setConsentFormSignedOption(entity))
  } catch (e) {
    yield put(throwPcrException(`getConsentFormSignedOptions() error: ${e}`))
  }
}

export function* getConsentFormSignedOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getConsentFormSignedOptions)
}
